module.exports = __webpack_public_path__ + "static/media/gifSix.1de03e67.gif";